const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

async function handleResponse(response) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Une erreur est survenue.');
  }
  return response.json();
}

function apiFetch(path, options = {}) {
  const finalOptions = {
    credentials: 'include',
    ...options
  };
  return fetch(`${API_BASE_URL}${path}`, finalOptions).then(handleResponse);
}

function apiJson(path, method, payload) {
  return apiFetch(path, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: payload !== undefined ? JSON.stringify(payload) : undefined
  });
}

export function fetchProducts() {
  return apiFetch('/products');
}

export function fetchProduct(productId) {
  return apiFetch(`/products/${productId}`);
}

export function createProduct(payload) {
  return apiJson('/products', 'POST', payload);
}

export function updateProduct(productId, payload) {
  return apiJson(`/products/${productId}`, 'PUT', payload);
}

export function deleteProduct(productId) {
  return apiFetch(`/products/${productId}`, { method: 'DELETE' });
}

export function fetchClubInfo() {
  return apiFetch('/club');
}

export function updateClubHistory(history, updatedBy) {
  return apiJson('/club/history', 'PUT', { history, updatedBy });
}

export function createOrder(payload) {
  return apiJson('/orders', 'POST', payload);
}

export function fetchOrders() {
  return apiFetch('/orders');
}

export function updateOrderStatus(orderId, status) {
  return apiJson(`/orders/${orderId}/status`, 'PATCH', { status });
}

export function deleteOrder(orderId) {
  return apiFetch(`/orders/${orderId}`, { method: 'DELETE' });
}

export function fetchNextMatch() {
  return apiFetch('/matches/next');
}

export function updateNextMatch(payload) {
  return apiJson('/matches/next', 'PUT', payload);
}

export function updateFanionNews(cards) {
  return apiJson('/club/fanion-news', 'PUT', { cards });
}

export function updateExpressNews(text) {
  return apiJson('/club/express-news', 'PUT', { text });
}

export function updateLastMatchInfo(payload) {
  return apiJson('/club/last-match', 'PUT', payload);
}

export function updateCalendarContent(calendarText, calendarPdf) {
  return apiJson('/club/calendar', 'PUT', { calendarText, calendarPdf });
}

export function updateCategoryImages(categoryImages) {
  return apiJson('/club/categories', 'PUT', { categoryImages });
}

export function updateAlbumPhotos(photos) {
  return apiJson('/club/album', 'PUT', { photos });
}

export function updatePartnerLogos(partners) {
  return apiJson('/club/partners', 'PUT', { partners });
}

export function updateCarouselImages(images) {
  return apiJson('/club/carousel', 'PUT', { images });
}

export function submitSponsorRequest(payload) {
  return apiJson('/club/sponsor-request', 'POST', payload);
}

export function submitMembershipRequest(payload) {
  return apiJson('/club/membership-request', 'POST', payload);
}

export function submitAdhesionRequest(payload) {
  return apiJson('/club/adhesion-request', 'POST', payload);
}

export function registerUser(payload) {
  return apiJson('/users/register', 'POST', payload);
}

export function loginUser(payload) {
  return apiJson('/users/login', 'POST', payload);
}

export function logoutCurrentUser() {
  return apiFetch('/users/logout', { method: 'POST' });
}

export function fetchUsersList() {
  return apiFetch('/users');
}

export function verifyUserToken(token) {
  return apiJson('/users/verify', 'POST', { token });
}

export function fetchUserProfile(userId) {
  return apiFetch(`/users/${userId}`);
}

export function updateUserAddress(userId, payload) {
  return apiJson(`/users/${userId}/address`, 'PATCH', payload);
}

export function updateUserPassword(userId, payload) {
  return apiJson(`/users/${userId}/password`, 'PATCH', payload);
}

export function resetPasswordWithEmail(email, newPassword) {
  return apiJson('/users/reset-password', 'POST', { email, newPassword });
}

export function updateUserRole(userId, role) {
  return apiJson(`/users/${userId}/role`, 'PATCH', { role });
}

export function updateUserDiscount(userId, discountPercent) {
  return apiJson(`/users/${userId}/discount`, 'PATCH', { discountPercent });
}

export function deleteUserAccount(userId) {
  return apiFetch(`/users/${userId}`, { method: 'DELETE' });
}

export function ensureSession() {
  return apiFetch('/session');
}

export function fetchCurrentSessionUser() {
  return apiFetch('/session/me');
}

export function terminateSession() {
  return apiFetch('/session/logout', { method: 'POST' });
}

export function fetchCartItems() {
  return apiFetch('/cart');
}

export function saveCartItems(items) {
  return apiJson('/cart', 'PUT', { items });
}

export function clearCartOnServer() {
  return apiFetch('/cart', { method: 'DELETE' });
}
